import React, { useState } from 'react';
import UpIcon from '@tradera/blueprint/theme/icons2/arrow-up.svg?jsx';
import DownIcon from '@tradera/blueprint/theme/icons2/arrow-down.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';

const MoreInfoFoldOut = ({ triggerText, infoText }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className="mb-1">
            <Button
                theme="link"
                className="my-0 px-0"
                onClick={() => setIsOpen(!isOpen)}>
                {triggerText}
                {isOpen ? (
                    <UpIcon className="icon icon-after" />
                ) : (
                    <DownIcon className="icon icon-after" />
                )}
            </Button>
            {isOpen && <div className="mb-0">{infoText}</div>}
        </div>
    );
};

export default MoreInfoFoldOut;
